<template>
    <div class="date-time-picker">
        <div class="row">
            <div :class="{'col-md-6' : !manualValueSet, 'col-md-8' : manualValueSet}">
                <b-form-datepicker
                    v-model="date"
                    :reset-value="initialValue || null"
                    :initial-date="getInitialDate()"
                ></b-form-datepicker>
            </div>
            <div :class="{'col-md-5' : !manualValueSet, 'col-md-4' : manualValueSet}" v-if="!hideTime">
                <b-form-timepicker
                    :value="time"
                    v-model="time"
                    :show-seconds="true"
                ></b-form-timepicker>
            </div>
            <div class="col-md-1" v-if="!manualValueSet">
              <button type="button" variat class="btn btn-outline-warning btn-inline" @click="setTimeToNull()"  v-b-tooltip :title="nullValueLabel"><i class="fa fa-times"></i></button>
            </div>
        </div>
        <div class="row mt-3" v-if="manualValueSet">
            <div class="col-md-8 align-items-center" v-for="button in manualValueSet">
              <div class="suggested_publish_date btn btn-warning w-100" @click="setManualValue(button)">
                <i class="fa fa-exclamation-circle"></i>
                <span>{{ $lang.get('page.Suggested Publish Date') }}: {{formatDate(button)}}</span>
              </div>
            </div>
            <div class="col-md-4 align-items-center">
              <button type="button" class="btn btn-light btn-inline w-100" @click="setTimeToNull()"><i class="fa fa-times"></i> {{nullValueLabel}}</button>
            </div>
        </div>
        <input type="hidden" :value="renderValue()" :name="name" />
    </div>
</template>
<style scoped>
    .date-time-picker {
        display: block;
        width: 100%;
    }
    .date-time-picker .btn-inline {
      white-space: nowrap;
    }
</style>
<script>
    import {DateTime} from "luxon";

    export default {

        props: ['name', 'initialValue', 'allowNull', 'nullValueLabel', 'hideTime' , 'manualValueSet'],

        data: () => { return {
            date: null,
            time: null,
        }},

        mounted: function() {
          this.renderDate();
        },

      watch: {
            date: function() {
                this.emitModel();
            },
            time: function() {
                this.emitModel();
            },
        },

        methods: {
            getInitialDate: function() {
                if (!this.initialValue) {
                    return DateTime.local().toISODate();
                }

                if(this.initialValue.length === 10) {
                    return this.initialValue + ' 00:00:00';
                }

                return this.initialValue;
            },

            renderValue: function() {
                if (!this.date) {
                    return '';
                }

                if (this.hideTime) {
                    return this.date;
                }

                if (!this.time) {
                    return this.date + ' 00:00:00';
                }

                return this.date + ' ' + this.time;
            },

            renderDate: function () {
                if (!this.initialValue || this.date || this.time) {
                  return;
                }

                let format = this.initialValue.length === 10
                    ? 'yyyy-MM-dd'
                    : 'yyyy-MM-dd HH:mm:ss';

                let datetime = DateTime.fromFormat(this.initialValue, format);

                this.date = datetime.toISODate()
                this.time = datetime.toISOTime({suppressMilliseconds: true, includeOffset: false});
            },

            setTimeToNull: function() {
                this.date = null;
                this.time = null;

                this.$emit('input', null);
            },

            emitModel: function() {
                this.$nextTick(() => {
                    this.$emit('input', this.renderValue());
                });
            },

            setManualValue: function (value) {

              let format = value.length === 10
                  ? 'yyyy-MM-dd'
                  : 'yyyy-MM-dd HH:mm:ss';

              let datetime = DateTime.fromFormat(value, format);

              this.date = datetime.toISODate()
              this.time = datetime.toISOTime({suppressMilliseconds: true, includeOffset: false});

            },

            formatDate: function (value) {

              let format = value.length === 10
                  ? 'yyyy-MM-dd'
                  : 'yyyy-MM-dd HH:mm:ss';

              let datetime = DateTime.fromFormat(value, format);
              let formatedDate = (''+ datetime.day).padStart(2,'0') + '/' + (''+ datetime.month).padStart(2,'0') + '/' + datetime.year;

              if(value.length > 10) {
                  formatedDate += ' ' + datetime.toISOTime({suppressMilliseconds: true, includeOffset: false});
              }

              return formatedDate;

            }
        },

    }
</script>
